import * as React from 'react'
import { useLocale, useRecording } from '../../providers'
import { RecorderIntro } from './RecorderIntro'
import { RecorderForm, RecorderFormValues } from './RecorderForm'
import { RecorderAudioInput } from './RecorderAudioInput'
import { RecorderViewWrapper } from './styles'
import { CenteredContent } from '../../theme'

const { useState } = React

export const Recorder: React.FC = () => {
  const [showIntro, setShowIntro] = useState(true)
  const [formValues, setFormValues] = useState<RecorderFormValues | null>(null)
  const [submissionStatus, setSubmissionStatus] = useState<'none' | 'waiting' | 'success' | 'failure'>('none')
  const { getText } = useLocale()
  const { state } = useRecording()

  const proceed = () => {
    setShowIntro(false)
  }

  const handleSubmit = (values: RecorderFormValues) => setFormValues(values)

  const submitRecording = async (audioUrl: string, durationMillis: number, values: RecorderFormValues) => {
    try {
      setSubmissionStatus('waiting')

      const audioBlob = await fetch(audioUrl).then(res => res.blob())
      const toBase64 = (blob: Blob) =>
        new Promise<string>((resolve, reject) => {
          const reader = new FileReader()
          reader.readAsDataURL(blob)
          reader.onloadend = () => resolve(reader.result as string)
          reader.onerror = reject
        })
      const base64Audio = await toBase64(audioBlob)
      const durationSeconds = durationMillis / 1000

      const response = await fetch('/api/uploadRecording', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          metadata: {
            name: values.name,
            location: values.location,
            duration: durationSeconds,
          },
          audioFile: base64Audio,
        }),
      })
      if (!response.ok) throw new Error('Upload failed')
      await response.json()
      setSubmissionStatus('success')
    } catch (error) {
      setSubmissionStatus('failure')
    }
  }

  if (state.permissionGranted === false) {
    return <p>{getText('permissionsNeededMessage')}</p>
  }

  let mainContent
  if (showIntro) {
    mainContent = <RecorderIntro proceed={proceed} />
  } else if (formValues === null) {
    mainContent = <RecorderForm handleSubmit={handleSubmit} />
  } else if (submissionStatus === 'waiting') {
    mainContent = <p>{getText('loadingMessage')}...</p>
  } else if (submissionStatus === 'success') {
    mainContent = <p style={{ marginTop: '3rem' }}>{getText('submissionThankYou')}</p>
  } else if (submissionStatus === 'failure') {
    mainContent = <p>{getText('submissionError')}</p>
  } else {
    mainContent = (
      <RecorderAudioInput
        formValues={formValues}
        onSubmitRequested={(audioUrl, durationMillis) => {
          if (formValues) {
            submitRecording(audioUrl, durationMillis, formValues)
          }
        }}
      />
    )
  }

  return (
    <CenteredContent>
      <RecorderViewWrapper>
        {mainContent}
      </RecorderViewWrapper>
    </CenteredContent>
  )
}
